// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2V7Jl","unreadBadge":"styles_unreadBadge__YDEjv","modalContent":"styles_modalContent__UPtOZ","modal":"styles_modal__3fCYd"};